exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.file-upload[data-v-2620c2d6] {\n    display: flex;\n    flex-direction: column;\n    max-width: 300px;\n}\ninput[type=\"file\"][data-v-2620c2d6] {\n    margin-bottom: 10px;\n}\n.btn-rename[data-v-2620c2d6] {\n    cursor: pointer;\n    padding: 2px !important;\n    font-size: .8em !important;\n}\n.btn-rename[data-v-2620c2d6]:hover {\n    background: #9fcdff;\n    border: 1px solid;\n    color: #0e0b04;\n}\n.btn-rename[data-v-2620c2d6]:active {\n    background: #6290c5;\n}\n", ""]);

// exports
